export default __webpack_public_path__ + "static/media/Leggings of the Savage Fang.14f147ec.jpg";